import { render, staticRenderFns } from "./TermsContent.vue?vue&type=template&id=918a33c4&scoped=true"
import script from "./TermsContent.vue?vue&type=script&lang=js"
export * from "./TermsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918a33c4",
  null
  
)

export default component.exports